const CMS = {
  cms: 'CMS',
  addCMS: 'Add CMS',
  editCMS: 'Edit CMS',
};
export default CMS;
